(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["w74-product-add-ons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-w74-addon-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    const button = form.querySelector('[data-w74-addon-button]');
    const status = form.querySelector('[data-w74-addon-status]');
    const defaultLabel = button.textContent.trim();
    const addingLabel = form.dataset.addingLabel || defaultLabel;
    const addedLabel = form.dataset.addedLabel || defaultLabel;
    const errorLabel = form.dataset.errorLabel || defaultLabel;

    button.disabled = true;
    button.textContent = addingLabel;

    if (status) {
      status.textContent = '';
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: new FormData(form),
      });

      if (!response.ok) {
        throw new Error('Add-on could not be added');
      }

      button.textContent = addedLabel;

      if (status) {
        status.textContent = addedLabel;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      button.textContent = errorLabel;

      if (status) {
        status.textContent = errorLabel;
      }
    }

    window.setTimeout(() => {
      button.disabled = false;
      button.textContent = defaultLabel;

      if (status) {
        status.textContent = '';
      }
    }, 1600);
  });
  } catch(e) { console.error(e); }
})();

})();
